import { useMutation, UseMutationOptions, useQueryClient } from "react-query";
import { useCurrentTrip } from "@/hooks";
import { TASK_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";

type MarkTaskCompleteVariables = {
  taskId: number;
};

type MarkTaskCompleteResult = {
  success: boolean;
  result: {
    message: string;
  };
};

type QueryError = {};

const useMarkTaskCompleteMutation = (
  options?: UseMutationOptions<
    MarkTaskCompleteResult,
    QueryError,
    MarkTaskCompleteVariables
  >
) => {
  const { fetchWithAuth, cancel } = useFetchWithAuth();
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const queryClient = useQueryClient();
  const tasksCacheKey = [`${TASK_ENDPOINT}/trip-task/trip/${tid}`];

  return {
    ...useMutation<
      MarkTaskCompleteResult,
      QueryError,
      MarkTaskCompleteVariables
    >(
      async ({ taskId }: MarkTaskCompleteVariables) => {
        const url = `${TASK_ENDPOINT}/trip-task/mark/complete/task/${taskId}/trip/${tid}`;

        return fetchWithAuth<MarkTaskCompleteResult>(url, {
          method: "PATCH",
          // body: { tid: tid, task_id: taskId, complete: 1 },
        });
      },
      {
        ...options,
        onSuccess: async (
          resultData: MarkTaskCompleteResult,
          data: MarkTaskCompleteVariables
        ) => {
          queryClient.invalidateQueries(tasksCacheKey);
        },
      }
    ),
    cancel,
  };
};

export default useMarkTaskCompleteMutation;
